import React from "react";
import PolicyPageLayout, { PolicyList, PolicySection } from "./PolicyPageLayout";
import { COMPANY_DETAILS } from "./policyData";

const RefundPolicy = () => {
  return (
    <PolicyPageLayout
      title="Refund & Cancellation Policy"
      subtitle="This policy explains when an order or service can be cancelled, when a refund may be approved, how online payment issues are handled, and how refunds are processed for PhonePe and other authorised payment methods."
    >
      <PolicySection title="1. Order Cancellation">
        <PolicyList
          items={[
            "Cancellation requests are considered only before the order is dispatched or before service work has substantially started.",
            "Once an item has been shipped, handed to a courier, specially procured, or a repair process has begun after your approval, cancellation may not be possible.",
            "To cancel an order, contact our support team immediately with your order ID and registered mobile number.",
          ]}
        />
      </PolicySection>

      <PolicySection title="2. Failed, Pending or Duplicate Payments">
        <PolicyList
          items={[
            "If payment is debited but no order confirmation is generated, please contact us with your payment reference, order details and registered mobile number.",
            "Failed or timed-out UPI or bank transactions may be auto-reversed by the banking network as per applicable bank, NPCI or RBI timelines.",
            "If we confirm a duplicate or excess payment during reconciliation, the eligible excess amount will be refunded to the original payment source.",
          ]}
        />
      </PolicySection>

      <PolicySection title="3. When a Refund May Be Approved">
        <PolicyList
          items={[
            "Payment was successfully collected but the order could not be fulfilled by us.",
            "A cancellation request was accepted before dispatch or before service execution.",
            "A returned item is approved after inspection as eligible under our Return Policy.",
            "A duplicate or excess payment is confirmed during our payment reconciliation.",
            "A payment was captured for an order that we reject because of stock, pricing, serviceability or verification failure.",
          ]}
        />
      </PolicySection>

      <PolicySection title="4. Situations Where Refund May Be Refused or Reduced">
        <PolicyList
          items={[
            "The return request does not satisfy the conditions mentioned in our Return Policy.",
            "The issue is caused by customer misuse, accidental damage, liquid damage, power damage or unauthorised repair.",
            "Courier, convenience, pickup, handling or testing charges may be deducted where already incurred, if permitted under the applicable transaction terms.",
            "Refunds are not guaranteed merely because a customer changes their mind after product acceptance or service completion.",
          ]}
        />
      </PolicySection>

      <PolicySection title="5. Refund Method">
        <p>
          Approved refunds for online payments are normally processed back to
          the original payment source only. We do not promise cash refunds for
          online transactions except where required by law or specifically
          approved by our accounts team in exceptional cases.
        </p>
      </PolicySection>

      <PolicySection title="6. Refund Timeline After Approval">
        <PolicyList
          items={[
            "We usually initiate approved refunds within 2 business days after approval.",
            "After initiation, UPI and wallet refunds commonly reflect within 2 to 3 business days.",
            "Card refunds commonly reflect within 5 to 10 business days, subject to the issuing bank and card network.",
            "Net banking refunds commonly reflect within 5 to 7 business days, subject to banking timelines.",
          ]}
        />
        <p>
          Actual credit time may vary based on the bank, card issuer, UPI app
          or payment partner involved in the transaction.
        </p>
      </PolicySection>

      <PolicySection title="7. PhonePe and Payment Reconciliation">
        <p>
          PhonePe and similar payment partners only facilitate payment
          processing. Refund approval, product issues, service complaints,
          cancellations and merchant-side order resolution remain the
          responsibility of {COMPANY_DETAILS.name}. If your payment is
          successful on PhonePe or another payment partner but your order
          confirmation is delayed, we will verify the transaction status and
          either confirm the order or process the eligible refund.
        </p>
      </PolicySection>

      <PolicySection title="8. Chargebacks and Dispute Handling">
        <p>
          We encourage customers to contact us first for refund or order
          support so we can verify the transaction and provide a faster
          resolution. In case of a bank or card dispute, we may submit order,
          delivery, communication and refund records to the relevant payment
          partner or bank for investigation.
        </p>
      </PolicySection>

      <PolicySection title="9. How to Request Refund Support">
        <p>
          Please contact our support team by phone or email and share your order
          ID, payment reference, issue summary and any supporting images or
          video if applicable. Refund-related decisions are subject to
          verification and final approval by our team.
        </p>
      </PolicySection>
    </PolicyPageLayout>
  );
};

export default RefundPolicy;
